import { motion } from 'framer-motion';
import {
  BoltIcon,
  CodeBracketIcon,
  CpuChipIcon,
  CubeIcon,
  DevicePhoneMobileIcon,
  PaintBrushIcon,
} from '@heroicons/react/24/outline'

const services = [
  {
    name: 'Website Development',
    description: 'Modern websites, dashboards, and e-commerce platforms built with strong UX, clean interfaces, and practical business goals in mind.',
    icon: CodeBracketIcon,
  },
  {
    name: 'Mobile App Development',
    description: 'Cross-device app experiences that feel fast, intuitive, and ready for real users from the first release.',
    icon: DevicePhoneMobileIcon,
  },
  {
    name: 'AI Integration',
    description: 'Practical AI features for your applications, whether it’s chatbots, recommendation engines, or advanced data analytics.',
    icon: CpuChipIcon,
  },
  {
    name: 'Task Automation',
    description: 'Automated workflows that remove repetitive manual work and keep operations running smoothly as you grow.',
    icon: BoltIcon,
  },
  {
    name: '3D Printing',
    description: 'From prototype to final part, precise 3D printed models and products backed by a real production pipeline.',
    icon: CubeIcon,
  },
  {
    name: 'Graphics & UI/UX Design',
    description: 'Eye-catching logos, brand systems, and intuitive UI/UX design that capture your identity and help you stand out.',
    icon: PaintBrushIcon,
  },
]

export default function OurServices() {
  return (
    <div className="relative py-24 transition-colors duration-300 dark:bg-dark-bg sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-4 flex items-center gap-2">
          <span className="h-2 w-2 flex-none rounded-sm bg-secondary" aria-hidden="true" />
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-secondary-dark dark:text-secondary">Our services</p>
        </div>
        <h2 className="max-w-2xl text-pretty text-3xl font-semibold tracking-tight text-gray-950 dark:text-white sm:text-4xl">
          Stay on top of your game with focused digital services.
        </h2>

        <dl className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {services.map((service, index) => {
            const Icon = service.icon;

            return (
              <motion.div
                key={service.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.06 }}
                className="group relative rounded-lg border border-gray-200 bg-white p-6 transition duration-200 hover:border-secondary/60 dark:border-white/10 dark:bg-white/5"
              >
                <div className="flex items-start justify-between gap-4">
                  <dt className="text-lg font-semibold leading-6 text-gray-950 dark:text-white">
                    {service.name}
                  </dt>
                  <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full border border-secondary/40 text-secondary-dark transition duration-200 group-hover:bg-secondary group-hover:text-primary dark:text-secondary dark:group-hover:text-primary">
                    <Icon aria-hidden="true" className="h-5 w-5" />
                  </div>
                </div>
                <dd className="mt-3 text-sm leading-6 text-gray-600 dark:text-gray-400">{service.description}</dd>
              </motion.div>
            );
          })}
        </dl>
      </div>
    </div>
  )
}
